import Input from './Input';
import './Input.scss';

export default Input;
